import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subscription } from './subscription';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private http: HttpClient) { }

  // Get Subscriptions
  getSubscriptions(params: any): Observable<Subscription[]> {
    return this.http.get<Subscription[]>(`/subscriptions`, {
      params: params
    });
  }
}
